module.exports = __webpack_public_path__ + "static/media/BW.eb85e486.png";